import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import VerifiedIcon from '@mui/icons-material/Verified';

const style = {
    position: "absolute" as "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};
interface props {
    serviceName?: any;
    openTrackingModal: boolean;
    setOpenTrackingModal?: any;
    requestModel?: any;
    setUpdateCart?: any;
    response?: any;
}
export default function TrackingCodeModal({
    serviceName,
    openTrackingModal,
    setOpenTrackingModal,
    requestModel,
    setUpdateCart,
    response
}: props) {

    const handleClose = () => setOpenTrackingModal(false);
    const handelVerify = () => {
        if (1) {
            handleClose();
        }
    };


    return (
        <div>
            <Modal
                open={openTrackingModal}
                onClose={handleClose}
                aria-labelledby="keep-mounted-modal-title"
                aria-describedby="keep-mounted-modal-description"
            >
                <Box
                    sx={style}
                    style={{ borderRadius: "6px", padding: "40px 70px 70px 60px" }}
                    className="ModalCmp textCenter "
                >
                    <Grid container>
                        <Grid item xs={12}>
                            <VerifiedIcon style={{ color: '#4CAF50', width: '45px', height: '45px' }} />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography className="textCenter mTop30 mbottom20">
                                سفارش شما با موفقیت ثبت گردید.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} className="mTop20">
                            <Button
                                onClick={handelVerify}
                                fullWidth
                                className="btnForm SuccessDefault"
                            >
                                متوجه شدم
                            </Button>
                        </Grid>
                    </Grid>

                </Box>
            </Modal>
        </div>
    );
}
